import styled from 'styled-components';

export const StyledAuthorizedResult = styled.div``;
